import { styled, Typography, Box, Container } from '@material-ui/core';
import theme from '../../../../../styles/theme';

export const TextWin = styled(Typography)({
  color: '#5BEC5B',
  fontWeight: 600,
  fontSize: '13px',
  textTransform: 'capitalize',
});

export const TextLoss = styled(Typography)({
  color: '#FF7A63',
  fontWeight: 600,
  fontSize: '13px',
  textTransform: 'capitalize',
});

export const ValueBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '60px',
  height: '28px',
  borderRadius: '8px',
  backgroundColor: theme.colors.background,
  marginLeft: '7px',
  '& .MuiTypography-root': {
    fontSize: '14px',
    color: '#ffffffdd',
  },
  '&:hover': {
    backgroundColor: '#1a1c38',
  },
});

export const RowBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  marginTop: '6px',
  padding: '2px 0',
  borderRadius: '6px',
  '&:hover .MuiBox-root': {
    background: '#1a1c38',
  },
  '& > .MuiBox-root:first-child': {
    fontSize: '14px',
    color: '#ffffffdd',
    fontWeight: 500,
  },
});

export const BodyBox = styled(Container)({
  display: 'flex',
  justifyContent: 'center',
  padding: '8px 12px',
  '& div > div:nth-child(2)': {
    marginTop: '1px',
  },
});
